import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import LiveHostStatus from '../../../Component/UI/LiveHostStatus';
import useReviewHostStatus from '../../Broadcast/useReviewHostStatus';

export default function ReviewBlackPlayer({ allVisible, onVisibilityChange }: {
  allVisible: boolean;
  onVisibilityChange: (visible: boolean) => void;
}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const reviewHost = useReviewHostStatus();

  useEffect(() => {
    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 18;
    const context = canvas.getContext('2d');
    if (!context || !canvas.captureStream) return;
    context.fillStyle = '#000';
    context.fillRect(0, 0, canvas.width, canvas.height);
    const stream = canvas.captureStream(1);
    const video = videoRef.current;
    if (video) {
      video.srcObject = stream;
      void video.play().catch(() => undefined);
    }
    return () => {
      stream.getTracks().forEach(track => track.stop());
      if (video) video.srcObject = null;
    };
  }, []);

  return <PlayerSurface><video ref={videoRef} autoPlay muted playsInline
    onClick={() => onVisibilityChange(!allVisible)} aria-label="결제 심사용 검은 영상" />
    {reviewHost && <LiveHostStatus interrupted={false} {...reviewHost} />}
  </PlayerSurface>;
}

const PlayerSurface = styled.div`
  position: absolute;
  inset: 0;
  background: #000;
  video { display: block; width: 100%; height: 100%; object-fit: cover; background: #000; }
`;
